import { Button } from "@/components/ui/button";
import { Download, Mail } from "lucide-react";
import { RevenueChart } from "./RevenueChart";
import { ResultsSummary } from "./ResultsSummary";

interface CalculatorResultsProps {
  totalRevenue: number;
  totalProfit: number;
  chartData: Array<{
    name: string;
    Revenue: number;
    Profit: number;
  }>;
  downloadResults: () => void;
  shareViaEmail: () => void;
}

export const CalculatorResults = ({
  totalRevenue,
  totalProfit,
  chartData,
  downloadResults,
  shareViaEmail
}: CalculatorResultsProps) => {
  console.log('CalculatorResults rendering with:', { totalRevenue, totalProfit });
  
  return (
    <div className="space-y-6 w-full">
      <RevenueChart chartData={chartData} />
      <ResultsSummary totalRevenue={totalRevenue} totalProfit={totalProfit} />
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Button 
          onClick={downloadResults} 
          variant="outline" 
          className="flex-1 border-primary/20 hover:bg-primary/5 text-sm sm:text-base py-2 h-auto"
        >
          <Download className="mr-2 h-4 w-4" />
          Download Results
        </Button>
        <Button 
          onClick={shareViaEmail} 
          variant="outline" 
          className="flex-1 border-primary/20 hover:bg-primary/5 text-sm sm:text-base py-2 h-auto"
        >
          <Mail className="mr-2 h-4 w-4" />
          Share via Email
        </Button>
      </div>
    </div>
  );
};